export const MODULE_NAME = 'panels';

export const ACTIONS = {
  SET_SINGLE_OPERATION_OUTPUT: `${MODULE_NAME}/SET_SINGLE_OPERATION_OUTPUT`,
};

export const MUTATIONS = {
  SET_SINGLE_OPERATION_OUTPUT: `${MODULE_NAME}/SET_SINGLE_OPERATION_OUTPUT`,
};
